import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getDataSecurityDataAccessSearchUser } from '@sonar-software/sonar-core';
import React from 'react';

import { LookAheadFilter, LookAheadFilterComponent } from './LookAheadFilter';

async function getDataAccessSearchUser({ queryString }: { queryString: string }) {
	const result = await getDataSecurityDataAccessSearchUser({ queryString });

	return result.data ?? [];
}

export const LookAheadSalesforceUser: LookAheadFilterComponent = (props) =>
	<LookAheadFilter
		{ ...props }
		endpoint={ getDataAccessSearchUser }
		placeholder={ COPY_SPECIFIC.TYPE_TO_SEARCH } />;

